import React from "react";
import environment from "environment";
import styled from "styled-components";

export const Wrapper = styled.section`
  display: none;
  @media only screen and (min-width: 992px) {
    display: inline-block;
    background-color: rgb(255, 209, 209);
    top: 30px;
    left: 0px;
    position: absolute;
    z-index: 10;
    border: 1px solid black;
    padding: 7px;
    width: 200px;
    border-top-right-radius: 11px;
    border-bottom-right-radius: 10px;
  }
`;
const DevBanner = props => <div>{environment.isDevelopment ? <Wrapper>Mode: Development</Wrapper> : null}</div>;

export default DevBanner;
